module.exports = new __parcel__URL__("cornershop-shopper-welcome.f893666c.webp").toString();